import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { EavDtoKeysEnum } from '@zaoblako/shared/modules/eav/enums/eav-dto-keys.enum';
import { EavCheckersEnum } from '@zaoblako/shared/modules/eav/enums/eav-checkers.enum';

import * as yup from 'yup';

/** EAV entity create and update APIs request body - DTO signature */
export interface EavEntityFormInterface {
  /** Entity values: dictionary where key is attribute unique ID and value is concrete value */
  values: Record<number, any>;
}

/** EAV entity create and update APIs request body - DTO schema */
export const EavEntityFormDto = SerdeDtoClass.create<EavEntityFormInterface>(EavDtoKeysEnum.EAV_ENTITY_FORM_DTO, {
  values: {
    label: 'Значения полей',
    serializer: yup.mixed(),
    checkers: [EavCheckersEnum.EAV_ATTRIBUTE_ASSERT_EXISTS_BY_KEYS],
  },
});
